import { Switch as AntdSwitch, SwitchProps as AntdSwitchProps } from "antd";
import { CMP_PREFIX } from "@/base/constant";

export interface SwitchProps extends AntdSwitchProps {}

export const switchPrefixCls = `${CMP_PREFIX}-switch`;

export const Switch = ({ ...props }: SwitchProps) => {
  return <AntdSwitch {...props} />;
};
